import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import { DonateModal } from './DonateModal';
export function DonateButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <motion.button onClick={() => setIsModalOpen(true)} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} className="flex items-center gap-2 px-4 py-2 rounded-full text-gray-400 hover:text-white hover:bg-white/5 transition-all text-sm font-medium" data-id="element-49">
        <Heart size={16} data-id="element-50" />
        <span data-id="element-51">Support Us</span>
      </motion.button>

      <DonateModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-52" />
    </>;
}